import React from 'react'
import { Avatar } from '@mote/ui'
import styled from '@xstyled/styled-components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { MoteCardAudioVisualization } from './MoteCardRichAudioVisualization'
import { moteCardFluidDimensionsAdjuster } from './fluidSizing'

const AVATAR_SIZES = {
  withTranscript: {
    min: 62,
    max: 138
  },
  withOutTranscript: {
    min: 90,
    max: 200
  }
}

export function MoteCardRichAvatarWithAnimation({
  transcript,
  createdByName,
  createdByAvatar
}) {
  const { paused: isPaused, playerDimensions } = useMotePlayer()

  const avatarSize = React.useMemo(() => {
    const { min, max } =
      transcript || (transcript && isPaused)
        ? AVATAR_SIZES.withTranscript
        : AVATAR_SIZES.withOutTranscript

    return moteCardFluidDimensionsAdjuster(max, min, playerDimensions?.width)
  }, [transcript, isPaused, playerDimensions])

  return (
    <Root tabIndex={-1} size={avatarSize * 1.5}>
      <Container size={avatarSize}>
        <MoteCardAudioVisualization />
        <StyledAvatar
          tabIndex={-1}
          size={avatarSize}
          name={createdByName}
          src={createdByAvatar}
        />
      </Container>
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  outline: none;
  pointer-events: none;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
`

const Container = styled.div`
  position: relative;
  border-radius: 50%;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
`

const StyledAvatar = styled(Avatar)`
  width: 100%;
  height: 100%;
`
